'use client'

import Link from 'next/link'

import { useCookieConsent } from './CookieConsentProvider'
import styles from './CookieBanner.module.scss'

/**
 * GDPR-compliant cookie consent banner.
 * Appears at the bottom of the page on first visit before any non-essential scripts load.
 * Provides Accept All, Reject All, and Cookie Settings buttons.
 */
const CookieBanner = () => {
  const { showBanner, acceptAll, rejectAll, openSettings } = useCookieConsent()

  if (!showBanner) return null

  return (
    <div
      className={styles.banner}
      role='dialog'
      aria-modal='false'
      aria-label='Cookie consent'
      aria-describedby='cookie-banner-text'
    >
      <div className={styles.content}>
        <p id='cookie-banner-text' className={styles.text}>
          We use cookies to improve your experience. By continuing to browse, you accept our{' '}
          <Link href='/cookie-policy' className={styles.link} prefetch={false} target='_blank' rel='noopener noreferrer'>
            Cookie Policy
          </Link>
          . You can{' '}
          <button
            type='button'
            className={styles.settingsLink}
            onClick={openSettings}
            aria-label='Open cookie settings to customize preferences'
          >
            manage your preferences
          </button>{' '}
          at any time.
        </p>
        <div className={styles.actions}>
          <button
            type='button'
            className={styles.buttonPrimary}
            onClick={acceptAll}
            aria-label='Accept all cookies'
          >
            Accept All
          </button>
          <button
            type='button'
            className={styles.buttonSecondary}
            onClick={rejectAll}
            aria-label='Reject all non-essential cookies'
          >
            Reject All
          </button>
        </div>
      </div>
    </div>
  )
}

export default CookieBanner
